/**
 * Customer app `durationUtils.formatDuration` — decimal hours to display string.
 */
export function formatConsumerDurationFromHours(hours: number): string {
  if (hours < 1) {
    const minutes = Math.round(hours * 60);
    return `${minutes} min`;
  }
  return `${hours.toFixed(2)} hrs`;
}

/**
 * Customer app `BookingScreen`: `booking.real_no_of_hours || mainCleaner?.no_of_hours || 0`
 */
export function consumerBookingDurationHours(booking: {
  real_no_of_hours?: number | null;
  cleaners?: Array<{ no_of_hours?: number } | null | undefined> | null;
}): number {
  const main = booking.cleaners?.[0];
  const real = booking.real_no_of_hours;
  if (real != null && Number.isFinite(Number(real)) && Number(real) > 0) {
    return Number(real);
  }
  return Number(main?.no_of_hours ?? 0);
}
